import * as React from "react";
import { MegamenuLink } from "./MegamenuLink";

export const MegamenuLinks = ({ settings, megamenuSM, level = null }: any) => {
    const { firstLevelLinks, secondLevelLinks, thirdLevelLinks } = megamenuSM;
    const { show_secondlevel_open_always, show_thirdlevel_open_always } = settings.section;

    const getFirstLeveLinks = () => {
        return firstLevelLinks;
    };

    // Determines the initial level to render based on the level prop
    const getInitialLinks = () => {
        if (level === 2) return secondLevelLinks;
        if (level === 3) return thirdLevelLinks;
        return firstLevelLinks;
    };

    // Recursive function to render links at any level
    const renderLinks = ( links, currentLevel) => {

        return links?.map((subItem, index) => {
            const hasSubLinks = subItem.links && subItem.links.length > 0;
            const shouldRenderSubLinks = (currentLevel === 2 && show_secondlevel_open_always) ||
                (currentLevel === 3 && show_thirdlevel_open_always) ||
                !level;

            return (
                <React.Fragment key={`${subItem.handle}-${index}`}>
                    <ul
                        className={`megamenu__link-container`}
                        onMouseEnter={() => megamenuSM.onLinkHover(subItem)}
                        onMouseDown={() => megamenuSM.onLinkHover(subItem)}
                        onClick={() => currentLevel === 1 && megamenuSM.handleFirstLevelClick(subItem)}
                    >
                        <MegamenuLink
                            settings={settings}
                            hasSubLinks={hasSubLinks}
                            subItem={subItem}
                            megamenuSM={megamenuSM}
                            onLinkClick={() => currentLevel === 1 && megamenuSM.handleFirstLevelClick(subItem)}
                        >
                            {shouldRenderSubLinks && hasSubLinks && (
                                renderLinks(subItem.links, currentLevel + 1)
                            )}
                        </MegamenuLink>
                    </ul>
                </React.Fragment>
            );
        });
    };

    return <>{renderLinks(getInitialLinks(), 1)}</>;
};
